import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img src="https://cdn.abacus.ai/images/ce62aaea-7192-4eab-8134-3539efec6757.png" alt="GiftBox Logo" className="w-10 h-10 rounded-lg object-cover" />
            <div>
              <h1 className="text-xl font-bold text-gray-800">GiftBox</h1>
              <p className="text-sm text-gray-500">Términos y Condiciones</p>
            </div>
          </div>
          <Link to="/" className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition">
            ← Volver a la Tienda
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">Términos y Condiciones de Uso</h1>
            <p className="text-gray-600">Última actualización: {new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Aceptación de los Términos</h2>
              <p className="text-gray-600 mb-4">
                Al acceder y utilizar el sitio web de GiftBox, usted acepta y se obliga a cumplir estos términos y condiciones. 
                Si no está de acuerdo con estos términos, por favor no utilice nuestros servicios.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Descripción de los Servicios</h2>
              <p className="text-gray-600 mb-4">
                GiftBox es una plataforma en línea que ofrece la venta de cajas de regalo personalizadas y productos relacionados. 
                Nos reservamos el derecho de modificar, suspender o discontinuar cualquier servicio en cualquier momento.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Productos y Precios</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>3.1 Disponibilidad:</strong> Los productos están sujetos a disponibilidad. Nos reservamos el derecho 
                  de limitar las cantidades de cualquier producto.
                </p>
                <p>
                  <strong>3.2 Precios:</strong> Todos los precios están expresados en pesos colombianos (COP) e incluyen 
                  impuestos aplicables. Los precios pueden cambiar sin previo aviso.
                </p>
                <p>
                  <strong>3.3 Descripciones:</strong> Nos esforzamos por ser lo más precisos posible en las descripciones 
                  de los productos. Sin embargo, no garantizamos que las descripciones sean completamente exactas.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Proceso de Compra</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>4.1 Realización del Pedido:</strong> Los pedidos se realizan a través de nuestro sitio web o 
                  mediante WhatsApp al completar el formulario de pedido.
                </p>
                <p>
                  <strong>4.2 Confirmación:</strong> Una vez realizado el pedido, nos pondremos en contacto para confirmar 
                  los detalles, disponibilidad y coordinar la entrega.
                </p>
                <p>
                  <strong>4.3 Pago:</strong> Los pagos se coordinan directamente con el cliente a través de los medios 
                  de pago disponibles (transferencia bancaria, nequi, efectivo, etc.).
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Entrega y Envío</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>5.1 Envío:</strong> Ofrecemos envío gratis según región, aplican condiciones específicas. 
                  Los costos de envío adicionales serán informados al cliente.
                </p>
                <p>
                  <strong>5.2 Tiempos de Entrega:</strong> Los tiempos de entrega varían según la ubicación y 
                  disponibilidad del producto. Los tiempos estimados serán informados durante la confirmación del pedido.
                </p>
                <p>
                  <strong>5.3 Responsabilidad:</strong> GiftBox no será responsable por retrasos en la entrega causados 
                  por terceros o circunstancias fuera de nuestro control.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Devoluciones y Reembolsos</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>6.1 Política de Devoluciones:</strong> Las devoluciones serán aceptadas únicamente en caso 
                  de que el producto llegue dañado o defectuoso.
                </p>
                <p>
                  <strong>6.2 Proceso:</strong> El cliente debe notificar cualquier problema dentro de las 24 horas 
                  siguientes a la recepción del producto.
                </p>
                <p>
                  <strong>6.3 Reembolsos:</strong> Los reembolsos se procesarán dentro de los 5-7 días hábiles 
                  después de la aprobación de la devolución.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Propiedad Intelectual</h2>
              <p className="text-gray-600 mb-4">
                Todo el contenido del sitio web, incluyendo但不限于 textos, imágenes, logos, y software, 
                es propiedad de GiftBox y está protegido por las leyes de propiedad intelectual.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Limitación de Responsabilidad</h2>
              <p className="text-gray-600 mb-4">
                En la máxima medida permitida por la ley, GiftBox no será responsable por ningún daño indirecto, 
                incidental, especial o consecuente que surja del uso o la incapacidad de uso de nuestros servicios.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Modificaciones de los Términos</h2>
              <p className="text-gray-600 mb-4">
                Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. 
                Las modificaciones entrarán en vigor tan pronto como se publiquen en el sitio web.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Contacto</h2>
              <div className="text-gray-600">
                <p className="mb-2">Para cualquier pregunta sobre estos términos y condiciones, contacte con:</p>
                <p><strong>Email:</strong> hola@giftbox.co</p>
                <p><strong>Teléfono:</strong> 300 123 4567</p>
                <p><strong>Dirección:</strong> Bogotá, Colombia</p>
              </div>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t">
            <p className="text-sm text-gray-500 text-center">
              © 2026 GiftBox. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Terms;